import React, {useEffect, useRef, useState} from 'react';
import Transition from '../Transition';
import gen_open_ai_resp from './open-ai';
import {ICONS} from '../../Constants/Icons';
import AppLoader from '../../HelperClasses/AppLoaderClasses/AppLoader';
import Markdown from 'markdown-to-jsx';
import SecondaryButton from '../../UI/Buttons/SecondaryButton';
import {addEditCollectionApi} from '../../Collections/ApisFunctions/Add&EditCollection';
import {ToastContainer} from 'react-toastify';
import ToastPopup from '../../HelperClasses/AppLoaderClasses/ToastPopup';
import {convertToValidJSON} from '../../utils/convertJson';
import {slug as slugChecker} from 'github-slugger';
import jsonIcon from '../../assets/jsonIcon.png';

const GenerateCollection = ({onCollectionCreateHandler}) => {
  const [open_form, setOpenForm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [collection_json, setCollectionJson] = useState('');

  //

  const trigger = useRef(null);
  const dropdown = useRef(null);

  // close if the esc key is pressed
  useEffect(() => {
    const keyHandler = ({keyCode}) => {
      if (!open_form || keyCode !== 27) return;

      setOpenForm(false);
    };
    document.addEventListener('keydown', keyHandler);
    return () => document.removeEventListener('keydown', keyHandler);
  });

  //
  const [openSide, setOpenSide] = useState('');

  useEffect(() => {
    function handleClickOutside(event) {
      if (trigger.current && !trigger.current.contains(event.target)) {
        // setOpenSide('')
      }
    }

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [trigger]);

  const onClickGenerate = async () => {
    setIsLoading(true);
    //   convert text to json
    console.log('collection_json', collection_json);

    //   convert text to json
    const collection_json_converted = convertToValidJSON(collection_json);

    collection_json_converted.expirable = false;
    collection_json_converted.medium = [1, 2, 3];
    collection_json_converted.condition_type = 2;
    collection_json_converted.active = true;
    collection_json_converted.view_type = 'horizontal';
    collection_json_converted.background_color = '#FFFFFF';
    collection_json_converted.conditions = {
      AND: {
        account_category_id: [],
      },
    };
    collection_json_converted.order_by = 0;
    collection_json_converted.slug = slugChecker(
      collection_json_converted.title,
    );

    //   json check
    if (
      collection_json_converted.name === '' ||
      collection_json_converted.description === undefined ||
      collection_json_converted.description === '' ||
      collection_json_converted.manual_ids === undefined ||
      collection_json_converted.manual_ids.length === 0 ||
      collection_json_converted.scope_type === undefined ||
      collection_json_converted.scope_type === ''
    ) {
      setIsLoading(false);
      ToastPopup({
        type: 'error',
        message: 'Please enter valid data',
      });
      return;
    }

    //

    await addEditCollectionApi({
      data: collection_json_converted,
      isEdit: false,
      isDuplicate: false,
    });
    // setCollectionJson('');
    setIsLoading(false);
    setOpenForm(false);
    onCollectionCreateHandler();
  };

  return (
    <>
      <div className={'  inline-flex  relative'}>
        <button
          ref={trigger}
          className=" text-gray-400"
          onClick={() => {
            setOpenForm(!open_form);
          }}>
          <img src={jsonIcon} alt="jsonIcon" className="w-10 h-10" />
        </button>

        {/*  */}
        <Transition
          show={open_form}
          tag="div"
          className={`origin-bottom-right z-10 absolute bottom-full  w-full  md:w-[450px]  bg-white border border-gray-200  rounded shadow-lg overflow-hidden mb-3 right-0`}
          enter="transition ease-out duration-200 transform"
          enterStart="opacity-0 -translate-y-2"
          enterEnd="opacity-100 translate-y-0"
          leave="transition ease-out duration-200"
          leaveStart="opacity-100"
          leaveEnd="opacity-0">
          {' '}
          <div className="  flex flex-col" ref={dropdown}>
            <div className=" px-4 py-2.5 bg-gray-100 flex items-center justify-between ">
              <p className=" text-sm font-semibold text-black">
                Collection Generator
              </p>

              {/*  */}
              <div className=" flex item gap-4">
                {!isLoading && (
                  <SecondaryButton
                    onClick={() => onClickGenerate()}
                    className=" !py-1 !px-2 !text-sm">
                    Create Collection
                  </SecondaryButton>
                )}
                {/* close button */}
                <button
                  className={'    flex flex-col  items-center justify-center  '}
                  onClick={() => {
                    setOpenForm(!open_form);
                  }}>
                  {ICONS.close}
                  <span className=" text-xs  font-light">ESC</span>
                </button>
              </div>
            </div>

            {/* iput box for taking json input */}
            {!isLoading && (
              <div className="p-4">
                <textarea
                  className="w-full h-48 border border-gray-300 rounded-md p-2"
                  placeholder="Enter JSON input"
                  value={collection_json}
                  onChange={e => setCollectionJson(e.target.value)}
                />
              </div>
            )}

            {isLoading && (
              <div className="   p-4  animate-pulse w-full space-y-2">
                <span className=" block w-full h-3 bg-[#3B3269] bg-opacity-[20%]  rounded-md" />
                <span className=" block w-full h-3 bg-[#3B3269] bg-opacity-[20%]  rounded-md" />
                <span className=" block w-full h-3 bg-[#3B3269] bg-opacity-[20%]  rounded-md" />
                <span className=" block w-full h-3 bg-[#3B3269] bg-opacity-[20%]  rounded-md" />
                <span className=" block w-full h-3 bg-[#3B3269] bg-opacity-[20%]  rounded-md" />
              </div>
            )}
          </div>
        </Transition>

        <ToastContainer />
      </div>
    </>
  );
};

export default GenerateCollection;
